precision highp float;
precision highp sampler2D;

#define USES_CATEGORIES <uses_categories>
#define VALUE_NUMBER_CHANNELS <value_number_channels>


// uniform float polynomialCoefDegree2;
// uniform float polynomialCoefDegree1;
// uniform float polynomialConstant;
uniform float opacity;
uniform float time;
uniform sampler2D tex0;
uniform sampler2D tex1;
uniform float tex0size;
uniform float tex1size;
uniform float tilePixelSize;
uniform bool categorySmoothTransition;
uniform bool timeInterpolation;
uniform bool interpolateTileEdge;

// texture on the neighborhood
uniform sampler2D texN0;
uniform sampler2D texN1;
uniform bool availableN;
uniform sampler2D texE0;
uniform sampler2D texE1;
uniform bool availableE;
uniform sampler2D texS0;
uniform sampler2D texS1;
uniform bool availableS;
uniform sampler2D texW0;
uniform sampler2D texW1;
uniform bool availableW;

in vec2 tex0coord;
in vec2 tex1coord;

out vec4 fragColor;

// // The folowing code will be autogenerated
<gradient_function_definitions>


// The folowing code will be autogenerated
<getColor_code>



float xNoTileEdgeInterpolation(sampler2D tex, vec2 texCoord) {
  vec4 texColorFull = texture(tex, texCoord);
  vec3 texColorFull255 = texColorFull.rgb * 255.;

  #if (VALUE_NUMBER_CHANNELS == 3)
    // With 3 channels, x is in [0., 16777215.]
    vec3 texColor = texColorFull255.<value_channels>;
    return texColor.r * 256. * 256. + texColor.g * 256. + texColor.b;
  #endif

  #if (VALUE_NUMBER_CHANNELS == 2)
    // With 2 channels, x is in [0., 65535.]
    vec2 texColor = texColorFull255.<value_channels>;
    return texColor.r * 256. + texColor.g;
  #endif

  #if (VALUE_NUMBER_CHANNELS == 1)
    // With 1 channel, x is in [0., 255.]
    return texColorFull255.<value_channels>;
  #endif
}



// Blinear interpolation
vec4 blerp(vec4 color_x0_y0, vec4 color_x0_y1, vec4 color_x1_y0, vec4 color_x1_y1, float x0, float y0, float x1, float y1, float x, float y) {
    vec4 q11 = (((x1 - x) * (y1 - y)) / ((x1 - x0) * (y1 - y0))) * color_x0_y0;
    vec4 q21 = (((x - x0) * (y1 - y)) / ((x1 - x0) * (y1 - y0))) * color_x1_y0;
    vec4 q12 = (((x1 - x) * (y - y0)) / ((x1 - x0) * (y1 - y0))) * color_x0_y1;
    vec4 q22 = (((x - x0) * (y - y0)) / ((x1 - x0) * (y1 - y0))) * color_x1_y1;
    return q11 + q21 + q12 + q22;
}


void main() {
  // image coordinate (still float) in [0, 512]
  vec2 tileImageCoord = tex0coord * tilePixelSize;

  // we don't want to interpolate the alpha channel because it does not contain
  // transparency but a category. Going from cat 1 to 3 would otherwise create a gradient passing
  // by category 2 and we don't want that. Hence, we look for a "center pixel" value.
  vec2 centerPixelUV = (floor(tileImageCoord) + 0.5) / tilePixelSize;

  float xTex0 = xNoTileEdgeInterpolation(tex0, tex0coord);
  float xTex1 = xNoTileEdgeInterpolation(tex1, tex1coord);

  if (interpolateTileEdge /*&& availableN && availableS && availableW && availableE*/) {

    // left side
    if (tileImageCoord.x < 0.5 && availableW) {
      // looking at the very right of the west tile
      float xTexW0 = xNoTileEdgeInterpolation(texW0, vec2(1., tex0coord.y));
      float xTexW1 = xNoTileEdgeInterpolation(texW1, vec2(1., tex0coord.y));

      float ratioCurrentTile = tileImageCoord.x + 0.5;

      xTex0 = ratioCurrentTile * xTex0 + (1. - ratioCurrentTile) * xTexW0;
      xTex1 = ratioCurrentTile * xTex1 + (1. - ratioCurrentTile) * xTexW1;
    } else

    // right side
    if (tileImageCoord.x > (tilePixelSize - 0.5) && availableE) {
      // looking at the very left of the east tile
      float xTexE0 = xNoTileEdgeInterpolation(texE0, vec2(0., tex0coord.y));
      float xTexE1 = xNoTileEdgeInterpolation(texE1, vec2(0., tex0coord.y));

      float ratioCurrentTile = 1. + ((tilePixelSize - 0.5) - tileImageCoord.x);

      xTex0 = ratioCurrentTile * xTex0 + (1. - ratioCurrentTile) * xTexE0;
      xTex1 = ratioCurrentTile * xTex1 + (1. - ratioCurrentTile) * xTexE1;
    } 

    // Note: left/right are on a separate if/else block then top bottom
    // so that top/bottom can benefit from the interpolation already done for left/right.
    // It's not entirely equivalent to having a proper bilinear on the corners
    // but it's better than having a single if/else block.
    // The alternative in order to have a proper bilinear in the corner would
    // be to ssend to GPU 4 more textures, mounted as an array (because otherwise that's too many uniforms)
    // and perform 4 texture reads intead of just maximum 2. Since fragments must all wait for the slowest,
    // this would have a hit on perf even more.

    // bottom side
    if (tileImageCoord.y < 0.5 && availableS) {
      // looking at the very top of the south tile
      float xTexS0 = xNoTileEdgeInterpolation(texS0, vec2(tex0coord.x, 1.));
      float xTexS1 = xNoTileEdgeInterpolation(texS1, vec2(tex0coord.x, 1.));

      float ratioCurrentTile = tileImageCoord.y + 0.5;

      xTex0 = ratioCurrentTile * xTex0 + (1. - ratioCurrentTile) * xTexS0;
      xTex1 = ratioCurrentTile * xTex1 + (1. - ratioCurrentTile) * xTexS1;
    } else

    // top side
    if (tileImageCoord.y > (tilePixelSize - 0.5) && availableN) {
      // looking at the very bottom of the north tile
      float xTexN0 = xNoTileEdgeInterpolation(texN0, vec2(tex0coord.x, 0.));
      float xTexN1 = xNoTileEdgeInterpolation(texN1, vec2(tex0coord.x, 0.));

      float ratioCurrentTile = 1. + ((tilePixelSize - 0.5) - tileImageCoord.y);

      xTex0 = ratioCurrentTile * xTex0 + (1. - ratioCurrentTile) * xTexN0;
      xTex1 = ratioCurrentTile * xTex1 + (1. - ratioCurrentTile) * xTexN1;

    }
  }
  

  // `x` is the multichannel value of the tile befaore the polynomial is computer (24bit integer)
  float x = timeInterpolation ? mix(xTex0, xTex1, time) : (time < 0.5 ? xTex0 : xTex1);

  // We apply the coeficient to get the value of the polynomial
  // y = f(x) = a*x^2 + b*x + c
  // where:
  //    a = polynomialCoefDegree2
  //    b = polynomialCoefDegree1
  //    c = polynomialConstant
  float polynomialCoefDegree2 = <polynomialCoefDegree2>;
  float polynomialCoefDegree1 = <polynomialCoefDegree1>;
  float polynomialConstant = <polynomialConstant>;

  // `y` is the result of computing the polynomial on `x`
  float y = polynomialCoefDegree2 * x * x + polynomialCoefDegree1 * x + polynomialConstant;

  // The category is the type associated to the measurement, while y is its intensity.
  // This is particularly useful in the context of precipitation radar where only the intensity
  // is not enough to categorize the precipitation. In this context, the category can be used to represent
  // the precipitation type (0: no data, 1: rain, 2: snow, etc.)
  // Not all measurements require using multiple categories, in this case, the value 0 is going to be the
  // default category.
  // int category = int((time < 0.5 ? tex0Color.a : tex1Color.a) * 255.);
  int category = 0;
  
  #if (USES_CATEGORIES == 1)
    category = int((time < 0.5 ?  texture(tex0, centerPixelUV).a : texture(tex1, centerPixelUV).a) * 255.);
  #endif

  vec4 color_Center = getColor(category, y);

  vec4 color = vec4(0., 0., 0., 0.);

  if (categorySmoothTransition) {

    vec2 centerPixelUV_N = vec2(
        (floor(tex0coord.x * tilePixelSize) + 0.5) / tilePixelSize,
        (floor(tex0coord.y * tilePixelSize) + 0.5 + 1.) / tilePixelSize
      );

      vec2 centerPixelUV_S = vec2(
        (floor(tex0coord.x * tilePixelSize) + 0.5) / tilePixelSize,
        (floor(tex0coord.y * tilePixelSize) + 0.5 - 1.) / tilePixelSize
      );

      vec2 centerPixelUV_E = vec2(
        (floor(tex0coord.x * tilePixelSize) + 0.5 + 1.) / tilePixelSize,
        (floor(tex0coord.y * tilePixelSize) + 0.5) / tilePixelSize
      );

      vec2 centerPixelUV_W = vec2(
        (floor(tex0coord.x * tilePixelSize) + 0.5 - 1.) / tilePixelSize,
        (floor(tex0coord.y * tilePixelSize) + 0.5) / tilePixelSize
      );


    if (tex0coord.x >= centerPixelUV.x) { // the current pixel is at the EAST of the center pixel coord
      int category_E = 0;
      #if (USES_CATEGORIES == 1)
        category_E = int((time < 0.5 ?  texture(tex0, centerPixelUV_E).<category_channel> : texture(tex1, centerPixelUV_E).<category_channel>) * 255.);
      #endif
      
      vec4 color_E = getColor(category_E, y);
      
      if (tex0coord.y >= centerPixelUV.y) { // the current pixel is at the NORTH of the center pixel coord
        // the current pixel is in the NORTH EAST quadrant
        int category_N = 0;
        
        #if (USES_CATEGORIES == 1)
          category_N = int((time < 0.5 ?  texture(tex0, centerPixelUV_N).<category_channel> : texture(tex1, centerPixelUV_N).<category_channel>) * 255.);
        #endif

        vec4 color_N = getColor(category_N, y);

        vec2 centerPixelUV_NE = vec2(
          (floor(tex0coord.x * tilePixelSize) + 0.5 + 1.) / tilePixelSize,
          (floor(tex0coord.y * tilePixelSize) + 0.5 + 1.) / tilePixelSize
        );

        int category_NE = 0;
        
        #if (USES_CATEGORIES == 1)
          category_NE = int((time < 0.5 ?  texture(tex0, centerPixelUV_NE).<category_channel> : texture(tex1, centerPixelUV_NE).<category_channel>) * 255.);
        #endif

        vec4 color_NE = getColor(category_NE, y);

        color = blerp(color_Center, color_N, color_E, color_NE, centerPixelUV.x, centerPixelUV.y, centerPixelUV_NE.x, centerPixelUV_NE.y, tex0coord.x, tex0coord.y);

      } else { // the current pixel is at the SOUTH of the center pixel coord
        // the current pixel is in the SOUTH EAST quadrant
        int category_S = 0;
        
        #if (USES_CATEGORIES == 1)
          category_S = int((time < 0.5 ?  texture(tex0, centerPixelUV_S).<category_channel> : texture(tex1, centerPixelUV_S).<category_channel>) * 255.);
        #endif

        vec4 color_S = getColor(category_S, y);

        vec2 centerPixelUV_SE = vec2(
          (floor(tex0coord.x * tilePixelSize) + 0.5 + 1.) / tilePixelSize,
          (floor(tex0coord.y * tilePixelSize) + 0.5 - 1.) / tilePixelSize
        );

        int category_SE = 0;
        
        #if (USES_CATEGORIES == 1)
          category_SE = int((time < 0.5 ?  texture(tex0, centerPixelUV_SE).<category_channel> : texture(tex1, centerPixelUV_SE).<category_channel>) * 255.);
        #endif

        vec4 color_SE = getColor(category_SE, y);

        color = blerp(color_S, color_Center, color_SE, color_E, centerPixelUV_S.x, centerPixelUV_S.y, centerPixelUV_E.x, centerPixelUV_E.y, tex0coord.x, tex0coord.y);
      }

    } else { // the current pixel is at the WEST of the center pixel coord
      int category_W = 0;
      
      #if (USES_CATEGORIES == 1)
        category_W = int((time < 0.5 ?  texture(tex0, centerPixelUV_W).<category_channel> : texture(tex1, centerPixelUV_W).<category_channel>) * 255.);
      #endif

      vec4 color_W = getColor(category_W, y);

      if (tex0coord.y >= centerPixelUV.y) { // the current pixel is at the NORTH of the center pixel coord
        // the current pixel is in the NORTH WEST quadrant
        int category_N = 0;
        
        #if (USES_CATEGORIES == 1)
          category_N = int((time < 0.5 ?  texture(tex0, centerPixelUV_N).<category_channel> : texture(tex1, centerPixelUV_N).<category_channel>) * 255.);
        #endif

        vec4 color_N = getColor(category_N, y);

        vec2 centerPixelUV_NW = vec2(
          (floor(tex0coord.x * tilePixelSize) + 0.5 - 1.) / tilePixelSize,
          (floor(tex0coord.y * tilePixelSize) + 0.5 + 1.) / tilePixelSize
        );

        int category_NW = 0;
        
        #if (USES_CATEGORIES == 1)
          category_NW = int((time < 0.5 ?  texture(tex0, centerPixelUV_NW).<category_channel> : texture(tex1, centerPixelUV_NW).<category_channel>) * 255.);
        #endif

        vec4 color_NW = getColor(category_NW, y);

        color = blerp(color_W, color_NW, color_Center, color_N, centerPixelUV_W.x, centerPixelUV_W.y, centerPixelUV_N.x, centerPixelUV_N.y, tex0coord.x, tex0coord.y);

      } else { // the current pixel is at the SOUTH of the center pixel coord
        // the current pixel is in the SOUTH WEST quadrant
        int category_S = 0;
        
        #if (USES_CATEGORIES == 1)
          category_S = int((time < 0.5 ?  texture(tex0, centerPixelUV_S).<category_channel> : texture(tex1, centerPixelUV_S).<category_channel>) * 255.);
        #endif

        vec4 color_S = getColor(category_S, y);

        vec2 centerPixelUV_SW = vec2(
          (floor(tex0coord.x * tilePixelSize) + 0.5 - 1.) / tilePixelSize,
          (floor(tex0coord.y * tilePixelSize) + 0.5 - 1.) / tilePixelSize
        );

        int category_SW = 0;
        
        #if (USES_CATEGORIES == 1)
          category_SW = int((time < 0.5 ?  texture(tex0, centerPixelUV_SW).<category_channel> : texture(tex1, centerPixelUV_SW).<category_channel>) * 255.);
        #endif

        vec4 color_SW = getColor(category_SW, y);

        color = blerp(color_SW, color_W, color_S, color_Center, centerPixelUV_SW.x, centerPixelUV_SW.y, centerPixelUV.x, centerPixelUV.y, tex0coord.x, tex0coord.y);
      }
    }
  } else {
    color = color_Center;
  }

  color.a *= opacity;
  fragColor = color;
}



